import React from "react";
import { MoveTriggerIcon } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

export const DraggableSubtaskItem = ({ isDragging, isPreview, disabled, children, className, disablePadding }) => {
  return (
    <div
      className={classNames("tw-box-border tw-flex tw-items-center tw-justify-center tw-gap-1/2 tw-group", className)}
    >
      {!disabled ? (
        <div
          className={classNames(
            "tw-w-6 tw-h-10 tw-flex tw-items-center tw-justify-center drag-handle tw-opacity-0 group-hover:tw-opacity-100",
            {
              "tw-opacity-100": isPreview,
            }
          )}
          data-testid="reorder-handle"
        >
          <MoveTriggerIcon
            height={11}
            width={11}
            style={{ opacity: isDragging ? 0 : 1 }}
          />
        </div>
      ) : null}
      <div
        className={classNames(
          "tw-rounded-lg tw-w-full",
          { "tw-bg-theme-200": isDragging },
          { "hover:tw-bg-theme-200": !isDragging && !isPreview },
          { "tw-bg-page-paper-main tw-shadow-md": isPreview }
        )}
        style={{
          padding: !disablePadding && isPreview ? "4px 36px 4px 8px" : "0px",
        }}
      >
        <div style={{ opacity: isDragging ? 0 : 1 }}>{children}</div>
      </div>
    </div>
  );
};

DraggableSubtaskItem.propTypes = {
  isDragging: PropTypes.bool,
  isPreview: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.string,
  disablePadding: PropTypes.bool,
};

DraggableSubtaskItem.defaultProps = {
  disablePadding: false,
};
